<template>
  <v-container>
    <v-autocomplete
      v-model="selectedType"
      :items="QrTypes"
      item-text="name"
      item-value="value"
      label="مدل کیوآر"
      outlined
      return-object
      dense
      @change="handleSelection"
      :search-input.sync="search"
    >
      <template v-slot:item="{ item }">
        <div class="d-flex row gap-3">
          <v-icon small> mdi-{{ item.icon }}</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item-content>
        </div>
      </template>
      <template v-slot:selection="{ item }">
        <v-icon small>mdi-{{ item.icon }}</v-icon>
        {{ item.name }}
      </template>
    </v-autocomplete>
  </v-container>
</template>

<script>
export default {
  name: "QrTypePicker",
  data() {
    return {
      QrTypes: [],
      search: "",
      selectedType: null,
    };
  },
  mounted() {
    this.QrTypes = this.getQrTypes();
  },
  methods: {
    handleSelection(item) {
      this.$emit("selectQr", item.value);
    },
    conso() {},
  },
};
</script>

<style scoped>
.gap-3 {
  gap: 12px;
}
.disabled-item {
  opacity: 0.5 !important;
  pointer-events: none !important;
}
</style>
